import { createRoutine } from 'redux-saga-routines';

export interface FetchCompanyCsvReportTriggerPayload {
  companySymbol: string;
}

export interface FetchCompanyCsvReportFailurePayload {
  status?: number;
  message: string;
}

export const fetchCompanyCsvReport = createRoutine<
  SimplePayloadCreator<FetchCompanyCsvReportTriggerPayload>, // trigger
  SimplePayloadCreator,
  SimplePayloadCreator, // success
  SimplePayloadCreator<FetchCompanyCsvReportFailurePayload>,
  SimplePayloadCreator
>('@/pages/CompanyReport/FETCH_CSV_FILE', {});
